import "./Contact.module.css";
import MainNavigation from "@/reusable_sections/Header";
import GetInTouch from "./sections/GetInTouch";
import ServiceAreas from "./sections/ServiceAreas";
import SiteFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <MainNavigation />
      <GetInTouch />
      <ServiceAreas />
      <SiteFooter />
    </div>;
}